import { getPersistenceData, removePersistenceData, setPersistenceData } from "./persistenceStorage";

const TokenKey = "Admin-Token";
const DarkModeKey = "DarkMode";

export function getToken() {
    try {
        const token = getPersistenceData(TokenKey);
        if (token.length > 10) return token;
        else return null;
    } catch (e) {
        return null;
    }
}

export function setToken(token) {
    setPersistenceData(TokenKey, token);
}

export function removeToken() {
    removePersistenceData(TokenKey);
}

export function removeUser() {
    removePersistenceData("u");
}

export function removeAdminUser() {
    removePersistenceData("sa");
}

export function setUser(user) {
    setPersistenceData("u", JSON.stringify(user), true);
}

export function setAdminUser(adminUser) {
    setPersistenceData("sa", JSON.stringify(adminUser), true);
}

export function getUser() {
    const maybeUserData = getPersistenceData("u");
    if (maybeUserData) {
        try {
            const user = JSON.parse(maybeUserData);
            return user;
        } catch (e) {
            return null;
        }
    } else {
        return null;
    }
}

export function getDarkMode() {
    return getPersistenceData(DarkModeKey) === "true";
}

export function setDarkMode(val) {
    setPersistenceData(DarkModeKey, val);
}

export function getAdminUser() {
    const maybeUserData = getPersistenceData("sa");
    if (maybeUserData) {
        try {
            return JSON.parse(maybeUserData);
        } catch (e) {
            return null;
        }
    } else {
        return null;
    }
}
